import { combineReducers } from 'redux';
import { fullScreenModeReducer } from './fullscreen-mode/full-screen-mode.state';

export default combineReducers({
    fullScreenMode: fullScreenModeReducer,
});
